module.exports = __webpack_public_path__ + "static/media/banner_DragonNTiger-half.5b556afa.png";